module.exports = __webpack_public_path__ + "img/flicker_top.d732501f.gif";